import React from 'react'

const LEVELS = [
  {
    title: 'LEVEL 1 — MINOR SERVICE GAP',
    description:
      "Minor quality issue with little or no impact on the client's journey.",
    deduction: '0-10%',
    examples: [
      'Missing bottled water',
      'Minor vehicle cleanliness issue',
      'Chauffeur not wearing a tie',
      'Chauffeur less personable than expected',
      'Same-class vehicle substitute',
      'Minor route deviation with no impact',
    ],
  },
  {
    title: 'LEVEL 2 — MODERATE SERVICE GAP',
    description:
      'Failure to provide an expected element of the service that affects comfort or professionalism but does not prevent successful completion.',
    deduction: '20-30%',
    examples: [
      'Child seat not provided',
      'Airport meet-and-greet sign missing',
      'No luggage assistance',
      'Incorrect vehicle preparation',
      'Vehicle interior below the expected premium standard',
      'Chauffeur dress code not compliant',
    ],
  },
  {
    title: 'LEVEL 3 — SIGNIFICANT SERVICE FAILURE',
    description:
      'Failure affecting the core service or causing major inconvenience to the client.',
    deduction: '50%',
    examples: [
      'Wrong vehicle category',
      'Unauthorised vehicle change',
      'Chauffeur late 15–30 minutes',
      'Poor vehicle condition',
      'Incorrect chauffeur information',
      'Communication failures affecting service',
      'Required trip status updates have not been completed',
      'Excessive route deviation',
      'Chauffeur unreachable before pickup',
    ],
  },
  {
    title: 'LEVEL 4 — COMPLETE SERVICE FAILURE',
    description:
      'Service not delivered or severe breach of operational or safety standards.',
    deduction: '100%',
    examples: [
      'No-show chauffeur',
      'Passenger forced to arrange alternative transport',
      'Dangerous driving',
      'Intoxicated chauffeur',
      'Physical or verbal misconduct',
      'Major safety issue with the vehicle',
      'Booking cancelled due to partner negligence',
      'Falsifying chauffeur or vehicle information',
      'Operating with an entirely different chauffeur or vehicle without informing ROLZO',
      'Fraudulent activity',
    ],
  },
]

const ServiceQualityAdjustmentsContent = () => (
  <>
    <p className='text-normal partner-document-intro'>
      Deductions are applied per booking according to the severity of the
      service gap. The level assigned reflects the impact on the client&apos;s
      journey.
    </p>
    {LEVELS.map(level => (
      <div key={level.title} className='partner-document-level'>
        <p className='text-bold partner-document-level-title'>
          <strong>{level.title}</strong>
        </p>
        <div className='partner-document-level-meta'>
          <div>
            <p className='partner-document-label'>DESCRIPTION</p>
            <p className='text-normal'>{level.description}</p>
          </div>
          <div className='partner-document-deduction'>
            <p className='partner-document-label'>STANDARD DEDUCTION</p>
            <p className='text-normal'>{level.deduction}</p>
          </div>
        </div>
        <p className='partner-document-label'>EXAMPLES</p>
        <ul className='partner-document-examples'>
          {level.examples.map(example => (
            <li key={example}>{example}</li>
          ))}
        </ul>
      </div>
    ))}
  </>
)

export default ServiceQualityAdjustmentsContent
